module.exports = __webpack_public_path__ + "static/img/welfare_4.4695ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconMenu/welfare_4.png
// module id = 81DL
// module chunks = 2